import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
// import 'bootstrap/dist/css/bootstrap.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

import configStore from 'redux/store/configStore';
import MainRouter from './MainRouter';
import '@atlaskit/css-reset';
import './index.css';

library.add(fas);
const { store, persistor } = configStore();

ReactDOM.render((
  <Provider store={store}>
    {/* <PersistGate loading={null} persistor={persistor}> */}
      <MainRouter />
    {/* </PersistGate> */}
  </Provider>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
